module.exports = __webpack_public_path__ + "assets/media/2.027a1e0f.wav";